var map = {
	"./automation.png": 9128,
	"./browserstack.png": 9805,
	"./crossplatform.png": 8068,
	"./freemium.png": 2887,
	"./git.png": 5705,
	"./gitlab.png": 4532,
	"./gitlab.svg": 7082,
	"./global.jpg": 44,
	"./illustration.jpg": 3215,
	"./jira.png": 6637,
	"./links.png": 9038,
	"./pattern.jpg": 6119,
	"./plane.png": 9571,
	"./plane.svg": 9867,
	"./play-icon.png": 6585,
	"./python.png": 4531,
	"./react.png": 3896,
	"./realtime.png": 8982,
	"./rectangle-31.png": 6613,
	"./test.jpeg": 8102,
	"./test.jpg": 5457,
	"./test.png": 1177,
	"./testcase.png": 2677,
	"./tick.png": 4586,
	"./webdriverio.png": 1689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9946;